<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormModel } from "@/hooks";

const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <nut-textarea v-bind="$attrs" />
</template>
